(function () {
  'use strict';

  function init() {

  const $ = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));

  // Announcement close (session-scoped)
  const ann = $('[data-tind-announcement]');
  if (ann) {
    const closeBtn = $('[data-tind-announcement-close]', ann);
    const storageKey = 'tind-announcement-closed';
    if (sessionStorage.getItem(storageKey) === '1') ann.hidden = true;
    if (closeBtn) closeBtn.addEventListener('click', () => {
      ann.hidden = true;
      try { sessionStorage.setItem(storageKey, '1'); } catch (e) {}
    });

    // Mobile: show announcements one at a time, rotating on the settings delay.
    // (Desktop keeps the inline row via CSS.)
    const annItems = $$('.tind-announcement__item', ann);
    if (annItems.length > 0) {
      const annDelay = (parseFloat(ann.dataset.rotateDelay) || 4) * 1000;
      let annIdx = 0;
      let annTimer = null;
      const annMobile = () => window.matchMedia('(max-width: 768px)').matches;
      const annShow = () => annItems.forEach((it, i) => it.classList.toggle('is-active', i === annIdx));
      const annStart = () => {
        annShow();
        if (annTimer || annItems.length < 2) return;
        annTimer = setInterval(() => {
          annIdx = (annIdx + 1) % annItems.length;
          annShow();
        }, annDelay);
      };
      const annStop = () => {
        if (annTimer) { clearInterval(annTimer); annTimer = null; }
        annIdx = 0;
        annItems.forEach((it) => it.classList.remove('is-active'));
      };
      const annSync = () => { annMobile() ? annStart() : annStop(); };
      annSync();
      window.addEventListener('resize', annSync);
    }
  }

  // Mobile menu drawer
  const menu = $('[data-tind-mobmenu]');
  const scrim = $('[data-tind-scrim]');
  const openBtns = $$('[data-tind-mobmenu-open]');
  const closeBtns = $$('[data-tind-mobmenu-close]');

  const openMenu = () => {
    if (!menu) return;
    menu.classList.add('tind-mobmenu--open');
    if (scrim) scrim.classList.add('tind-scrim--open');
    menu.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  };
  const closeMenu = () => {
    if (!menu) return;
    menu.classList.remove('tind-mobmenu--open');
    if (scrim) scrim.classList.remove('tind-scrim--open');
    menu.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };

  openBtns.forEach(b => b.addEventListener('click', openMenu));
  closeBtns.forEach(b => b.addEventListener('click', closeMenu));
  if (scrim) scrim.addEventListener('click', closeMenu);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeMenu(); });

  // Mobile menu expand/collapse groups
  $$('[data-tind-mobmenu-toggle]').forEach(btn => {
    btn.addEventListener('click', () => {
      const group = btn.closest('.tind-mobmenu__group');
      if (!group) return;
      const isOpen = group.classList.toggle('is-open');
      btn.classList.toggle('is-open', isOpen);
      btn.setAttribute('aria-expanded', String(isOpen));
    });
  });

  // Fading images (ingredients) — tab switch + auto-rotate
  $$('[data-tind-fading]').forEach(root => {
    const slides = $$('.fading__slide', root);
    const tabs = $$('[data-fading-tab]', root);
    const titleEl = $('[data-fading-current-title]', root);
    const textEl = $('[data-fading-text]', root);
    const dataScript = $('[data-fading-data]', root);
    let data = [];
    try { data = JSON.parse((dataScript?.textContent || '[]').trim()); } catch (_) { data = []; }
    if (!slides.length) return;

    let current = 0;
    const interval = parseInt(root.dataset.interval || '5000', 10);

    const show = (i) => {
      if (i === current) return;
      slides.forEach((s, idx) => s.classList.toggle('active', idx === i));
      tabs.forEach((t, idx) => t.classList.toggle('active', idx === i));
      if (data[i]) {
        if (titleEl) titleEl.textContent = data[i].title || '';
        if (textEl) textEl.textContent = data[i].text || '';
      }
      current = i;
    };

    tabs.forEach(tab => tab.addEventListener('click', () => {
      const i = parseInt(tab.dataset.index || '0', 10);
      show(i);
      clearInterval(timer);
      timer = setInterval(() => show((current + 1) % slides.length), interval);
    }));

    let timer = setInterval(() => show((current + 1) % slides.length), interval);
  });

  // Pin an element to the top of the viewport once you scroll past it.
  // position:sticky can't do this here because the header section wrapper is
  // too short, so the element is switched to position:fixed and a spacer is
  // inserted so the page doesn't jump. `shouldApply` gates it per breakpoint.
  //   - Desktop: pin the menu bar (brand bar scrolls away).
  //   - Mobile:  pin the brand bar, minimized (it carries the cart/menu icons).
  const tindStickyOnScroll = (el, shouldApply, fixedClass) => {
    if (!el) return;
    let fixed = false;
    let spacer = null;

    const fix = () => {
      if (fixed) return;
      if (!spacer) {
        spacer = document.createElement('div');
        spacer.className = 'tind-sticky-spacer';
        spacer.setAttribute('aria-hidden', 'true');
      }
      spacer.style.height = el.offsetHeight + 'px';
      el.parentNode.insertBefore(spacer, el);
      el.classList.add(fixedClass);
      fixed = true;
    };

    const unfix = () => {
      if (!fixed) return;
      el.classList.remove(fixedClass);
      if (spacer && spacer.parentNode) spacer.parentNode.removeChild(spacer);
      fixed = false;
    };

    const update = () => {
      if (!shouldApply()) { unfix(); return; }
      if (fixed) {
        if (window.scrollY <= parseFloat(el.dataset.dockY || '0')) unfix();
      } else {
        const dockY = el.getBoundingClientRect().top + window.scrollY;
        if (window.scrollY > dockY) {
          el.dataset.dockY = dockY;
          fix();
        }
      }
    };

    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => { update(); ticking = false; });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  };

  tindStickyOnScroll($('.tind-navbar'), () => window.innerWidth >= 769, 'tind-navbar--fixed');
  tindStickyOnScroll($('.tind-header'), () => window.innerWidth < 769, 'tind-header--fixed');

  } // end init

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
